import React from 'react';
import classNames from 'classnames';

const StripBadge = ({className, ...props}: React.HTMLProps<HTMLSpanElement>) => (
  <span className={classNames('StripBadge', className)} {...props}>
    <svg xmlns='http://www.w3.org/2000/svg' width='106' height='104' viewBox='0 0 106 104'>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <path
                fill='var(--theme-primary, #810ea9)'
                d='M5.733.602l142.493.684L124.47 24.95c-1.503 1.497-3.533 2.345-5.655 2.36l-88.766.673c-.858.006-1.684-.328-2.296-.93L4.322 4.03c-.788-.774-.8-2.04-.025-2.828C4.675.815 5.193.6 5.733.602z'
                transform='translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778) rotate(180 74.518 14.286)'
              />
              <text
                fill='#FFF'
                fontFamily='TypoCellcom-Bold, TypoCellcom'
                fontSize='14'
                fontWeight='bold'
                transform='translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778)'>
                <tspan x='120' y='20'>
                  במיוחד בשבילך
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default StripBadge;
